export default __webpack_public_path__ + "static/media/BookMarkBorderOutLined.3308208d.svg";